import { useCallback } from "react"

import { Tooltip } from "@mui/material"
import { useLocation, useMatch } from "react-router-dom"

import { useTranslation } from "@l2r-front/l2r-i18n"

import { I18N_NAMESPACE } from "../../constants/i18n"

import * as Styled from "./Kpi.styled"

export const KpiCard = (props) => {
    const {
        className,
        children,
        disabled = false,
        path,
        _subNetworksCount,
        title,
        titleEndAdornment,
        ...cardProps
    } = props

    const location = useLocation()
    const match = useMatch("/:selectedNetwork/:app/:module/*")
    const selectedNetwork = match?.params?.selectedNetwork
    const { t } = useTranslation(I18N_NAMESPACE)

    const previousPath = match?.params?.["*"].length ? match?.params?.["*"] : ""
    const fullPath = `/${selectedNetwork}/${path}/${previousPath}${location?.search ? location.search : ""}`

    const handleContextMenu = useCallback((event) => {
        event.preventDefault()
        event.stopPropagation()
    }, [])

    return (
        <Tooltip title={disabled && t(I18N_NAMESPACE, "components.kpiCard.disableTooltip")}>
            <Styled.KpiCard disabled={disabled} to={disabled ? "" : fullPath} className={className} onContextMenu={handleContextMenu} {...cardProps}>
                <Styled.TitleWrapper>
                    <Styled.CardTitle variant="Desktop & Mobile/Heading/H2">{title}</Styled.CardTitle>
                    {titleEndAdornment}
                </Styled.TitleWrapper>
                <Styled.ContentWrapper>
                    {disabled && <Styled.KpiCardDisabledOverlay>
                        <Styled.IconWrapperDisabled>
                            <Styled.LockedIcon color="gray/0" />
                        </Styled.IconWrapperDisabled>
                    </Styled.KpiCardDisabledOverlay>}
                    {children}
                </Styled.ContentWrapper>
            </Styled.KpiCard>
        </Tooltip>
    )
}
